import { GetWebsitePageResponse, GetWebsiteFormsResponse } from "../interfaces/api/get-website-page";
import { GetWebsitePagesResponse } from "../interfaces/api/get-website-pages";
import { PostGenerateAiResponse } from "../interfaces/api/post-generate-ai";
import { PostWebsitePageResponse } from "../interfaces/api/post-website-page";
import { PutWebsitePageResponse } from "../interfaces/api/put-website-page";
import { WebsitePage } from "../interfaces/WebsitePage";

const parseContentJson = (raw: WebsitePage["contentJson"]): WebsitePage["contentJson"] => {
  if (!raw) return { blocks: [] };
  if (typeof raw !== "string") return raw;

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : { blocks: [] };
  } catch {
    return { blocks: [] };
  }
};

const mapPage = (page: WebsitePage): WebsitePage => ({
  ...page,
  contentJson: parseContentJson(page.contentJson),
});

export const websitePageMapper = {
  mapResponseToPages(data: GetWebsitePagesResponse) {
    return (data.payload.pages || []).map(mapPage);
  },
  mapResponseToPage(data: GetWebsitePageResponse) {
    return mapPage(data.payload.page);
  },
  mapResponseToCreatedPage(data: PostWebsitePageResponse) {
    return mapPage(data.payload.page);
  },
  mapResponseToUpdatedPage(data: PutWebsitePageResponse) {
    return mapPage(data.payload.page);
  },
  mapResponseToForms(data: GetWebsiteFormsResponse) {
    return data.payload.forms || [];
  },
  mapResponseToAiContent(data: PostGenerateAiResponse) {
    return data.payload.content;
  },
};
